export default __webpack_public_path__ + "static/image-coming-soon-e535a79400f21c361a4ec988d655f0f4.png";